module.exports = __webpack_public_path__ + "img/49.d2aeee3b.d2aeee3b.svg";